import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ThemeProvider, useTheme } from "@/context/ThemeContext";
import { LogoProvider } from "@/context/LogoContext";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Caisse from "@/pages/Caisse";
import Seances from "@/pages/Seances";
import Equipements from "@/pages/Equipements";
import Nutrition from "@/pages/Nutrition";
import Utilisateurs from "@/pages/Utilisateurs";
import Historique from "@/pages/Historique";
import Membres from "@/pages/Membres";
import Presences from "@/pages/Presences";
import Rapports from "@/pages/Rapports";
import Journal from "@/pages/Journal";

function Protected({ children, adminOnly = false, perm = null }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background" data-testid="app-loading">
        <div className="text-muted-foreground text-sm animate-pulse">Chargement…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/" replace />;
  if (perm && user.role !== "admin" && !user.permissions?.[perm]) return <Navigate to="/" replace />;
  return children;
}

function ThemedToaster() {
  const { theme } = useTheme();
  return <Toaster position="top-right" richColors theme={theme} />;
}

function App() {
  return (
    <div className="App">
      <ThemeProvider>
      <LogoProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="/"
              element={
                <Protected>
                  <Layout />
                </Protected>
              }
            >
              <Route index element={<Dashboard />} />
              <Route path="caisse" element={<Caisse />} />
              <Route path="historique" element={<Historique />} />
              <Route path="membres" element={<Membres />} />
              <Route path="presences" element={<Protected perm="presences"><Presences /></Protected>} />
              <Route path="rapports" element={<Protected perm="rapports"><Rapports /></Protected>} />
              <Route path="seances" element={<Seances />} />
              <Route path="equipements" element={<Equipements />} />
              <Route path="nutrition" element={<Nutrition />} />
              <Route
                path="journal"
                element={
                  <Protected adminOnly>
                    <Journal />
                  </Protected>
                }
              />
              <Route
                path="utilisateurs"
                element={
                  <Protected adminOnly>
                    <Utilisateurs />
                  </Protected>
                }
              />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <ThemedToaster />
      </AuthProvider>
      </LogoProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;
